import { AbstractSceneTransition } from "appworks/graphics/layers/scene-transitions/abstract-scene-transition";
import { Contract } from "appworks/utils/contracts/contract";
import { gameLayers } from "game-layers";

export class TGRBalanceWrapTransition extends AbstractSceneTransition {

    public in(): Contract<void> {
        return Contract.wrap(() => {
            gameLayers.BetBar.elements.active.balance_value.style.wordWrap = false;
        });
    }
}
